import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import {
  CustomLinkComponent,
  DynamicTag,
  PageActionPlaceHolder,
  Spinner
} from 'msp-components'
import { useAccount } from 'msp-integrations'

import AccountMachineDisplay from '@/pages/account/AccountMachines/AccountMachineDisplay/AccountMachineDisplay'

import translations from './AccountOverviewMachines.constants'
import * as S from './AccountOverviewMachines.styles'

export type AccountOverviewMachinesProps = {
  className?: string
}

const AccountOverviewMachines = ({
  className = ''
}: AccountOverviewMachinesProps) => {
  const { formatMessage } = useIntl()
  const {
    machines: { isLoading, hasMachines, machines, getMachines }
  } = useAccount()
  const pageLink = '/account/my-machines'

  useEffect(() => {
    getMachines()
  }, [])

  return (
    <div className={twMerge(S.MainWrapper, className)}>
      <DynamicTag
        componentTagName='Headline'
        tag='h3'
        tagStyle='h6'
        className={S.Headline}
      >
        {formatMessage(translations.headline)}
      </DynamicTag>
      {isLoading && <Spinner />}
      {!isLoading && !hasMachines && (
        <PageActionPlaceHolder text={formatMessage(translations.noMachines)} />
      )}
      {!isLoading && hasMachines && (
        <AccountMachineDisplay
          className={S.ListItem}
          machine={machines[0]}
          disableActions
        />
      )}
      <CustomLinkComponent href={pageLink} className={S.Link}>
        {formatMessage(translations.headline)}
      </CustomLinkComponent>
    </div>
  )
}

export default AccountOverviewMachines
